import React from 'react';
import { Link } from 'react-router-dom';
import { APP_PAGES, appPagePath } from '../../devmap';
import './AppPageNav.css';

const GROUPS = [...new Set(APP_PAGES.map((p) => p.group))];

/**
 * The app's own pages, listed beside its panel — one line each, in three small
 * groups (Set up / Build / Results), the page in `?panel=` lit. A page may
 * carry a mark: `true` is a dot (something needs you there), a string is a
 * quiet count ("3", "13/15", "v7").
 *
 * `staged` lists the pages holding an uncommitted edit (utils/appState.js
 * stagedPages). Those carry a small "staged" tag in place of the count, so the
 * work waiting on a commit can be found from any page.
 */
export default function AppPageNav({ appId, active, marks = {}, staged = [] }) {
  return (
    <nav className="apppnav" aria-label="This app's pages">
      <Link to="/applications" className="apppnav__back">&larr; All apps</Link>
      {GROUPS.map((g) => (
        <div key={g} className="apppnav__group">
          <span className="apppnav__cap">{g}</span>
          {APP_PAGES.filter((p) => p.group === g).map((p) => {
            const mark = marks[p.id];
            const isStaged = staged.includes(p.id);
            return (
              <Link
                key={p.id}
                to={appPagePath(appId, p.id)}
                className="apppnav__item"
                aria-current={active === p.id ? 'page' : undefined}
              >
                <span>{p.label}</span>
                {mark === true && <i className="apppnav__dot" title="Needs you" />}
                {isStaged
                  ? <span className="apppnav__staged" title="Has a staged change, not live until you commit">staged</span>
                  : typeof mark === 'string' && mark && <span className="apppnav__count">{mark}</span>}
              </Link>
            );
          })}
        </div>
      ))}
    </nav>
  );
}
